// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";
import { ImageAPI, IUDAPI } from "../services/APIConnection";
import download from "../image/download.png";
import pdf from "../image/pdf.png";
import toast from "react-hot-toast";

const FileUpload = (props) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showImage, setShowImage] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [cancelImage, setCancelImage] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(props.disabledBtn);
  const fileInputRef = useRef(null);

  const MAX_FILE_SIZE_MB = props.MAX_FILE_SIZE_MB;
  const ALLOWED_FORMATS = props.ALLOWED_FORMATS;

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);
  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  // Clear parent error when component has its own error
  useEffect(() => {
    if (uploadError && props.clearImageUploadError) {
      props.clearImageUploadError();
    }
  }, [uploadError, props.clearImageUploadError]);

  useEffect(() => {
    setButtonDisable(props.disabledBtn);
  }, [props.disabledBtn]);

  useEffect(() => {
    if (props.clear) {
      // ✅ Clear input
      setSelectedFiles([]);
      setShowImage("");
      setUploadError("");
      setCancelImage(true);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      if (props.showImageData) {
        props.showImageData("");
      }
    }
  }, [props.clear]);

  // Clear component error when files are successfully selected
  useEffect(() => {
    if (selectedFiles.length > 0 && !uploadError && props.clearImageUploadError) {
      props.clearImageUploadError();
    }
  }, [selectedFiles, uploadError, props.clearImageUploadError]);

  const handleFileChange = (event) => {
    setButtonDisable(false);
    setShowImage(download);
    setSelectedFiles([]);
    const files = event.target.files;

    const selectedFilesLimited = Array.from(files)
      .filter((file) => isFileFormatAllowed(file) && isFileSizeBelowLimit(file))
      .slice(0, 3);

    if (selectedFiles.length + selectedFilesLimited.length > 3) {
      setUploadError("Cannot select more than 3 files");
      return;
    } else {
      setUploadError("");
    }

    setSelectedFiles((prevFiles) => [
      ...prevFiles,
      ...selectedFilesLimited.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
      })),
    ]);

    const unsupportedFormatFiles = Array.from(files).filter(
      (file) => !isFileFormatAllowed(file)
    );
    if (unsupportedFormatFiles.length > 0) {
      const unsupportedFilesNames = unsupportedFormatFiles
        .map((file) => file.name)
        .join(", ");
      setUploadError(`Unsupported file format: ${unsupportedFilesNames}`);
      return;
    } else {
      setUploadError("");
    }

    const oversizedFiles = Array.from(files).filter(
      (file) => !isFileSizeBelowLimit(file)
    );
    if (oversizedFiles.length > 0) {
      const errorMessage = `File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`;
      setUploadError(errorMessage);
      return;
    } else {
      setUploadError("");
    }
  };


  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");

  const handleUpload = async () => {
    
    if (props.clearImageUploadError) {
      props.clearImageUploadError();
    }

    setButtonDisable(true);
    setCancelImage(false);

    if (selectedFiles.length === 0) {
      setUploadError("Please select files to upload");

      // ❌ Failed Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: props.apiCall,
          action: "FILE UPLOAD",
          status: "FAILED",
          tableName: '',
          description: "File upload failed - No file selected",
        },
        "LogAPI/IUDLog"
      );

      return;
    }

    const formData = new FormData();
    formData.append(props.modalName, selectedFiles[0].file);

    if (props.mstClientId !== undefined && props.mstClientId !== null) {
      formData.append("MstClientId", props.mstClientId);
    }

    if (props.createdBy !== undefined && props.createdBy !== null) {
      formData.append("CreatedBy", props.createdBy);
    }

    try {
      const response = await ImageAPI(formData, props.apiCall);

      if (showImage) {
        props.showImageData(response.data);
        setShowImage(response.data);
      }

      setUploadError("");

      const uploadedFileName = selectedFiles[0].file.name.toLowerCase();

      let fileTypeMessage = "File";

      if (uploadedFileName.endsWith(".pdf")) {
        fileTypeMessage = "PDF";
      } else if (
        uploadedFileName.endsWith(".jpg") ||
        uploadedFileName.endsWith(".jpeg") ||
        uploadedFileName.endsWith(".png")
      ) {
        fileTypeMessage = "Image";
      }

      toast.success(`${fileTypeMessage} uploaded successfully ✅`, {
        duration: 3000,
        position: "top-center",
      });

      // ✅ Success Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: props.apiCall,
          action: "FILE UPLOAD",
          status: "SUCCESS",
          tableName: '',
          description: `File uploaded successfully - ${selectedFiles[0]?.file?.name || ""
            }`,
        },
        "LogAPI/IUDLog"
      );
    } catch (error) {
      console.error("Error uploading image:", error);

      setUploadError("Failed to upload image");

      // ❌ Failed Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: props.apiCall,
          action: "FILE UPLOAD",
          status: "FAILED",
          tableName: '',
          description: `File upload failed - ${error?.message || "Unknown Error"
            }`,
        },
        "LogAPI/IUDLog"
      );

      const uploadedFileName = selectedFiles[0].file.name.toLowerCase();

      let fileTypeMessage = "File";

      if (uploadedFileName.endsWith(".pdf")) {
        fileTypeMessage = "PDF";
      } else if (
        uploadedFileName.endsWith(".jpg") ||
        uploadedFileName.endsWith(".jpeg") ||
        uploadedFileName.endsWith(".png")
      ) {
        fileTypeMessage = "Image";
      }

      toast.error(`Failed to upload ${fileTypeMessage} 👎`, {
        duration: 2000,
        position: "top-center",
      });
    }
  };
  const handleCancel = async () => {
    
    setSelectedFiles([]);
    setShowImage("");
    setUploadError("");
    setCancelImage(true);
    setButtonDisable(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (props.showImageData) {
      props.showImageData("");
    }
    await IUDAPI(
      {
        mstClientId: parseInt(clientId, 10),
        mstUserId: parseInt(createdBy, 10),
        sp: `${props.apiCall}`,
        action: "File DELETE",
        status: "SUCCESS",
        tableName: '',
        description: `File deleted successfully. Total Files: - ${selectedFiles[0]?.file?.name || ""}`,
      },
      "LogAPI/IUDLog",
    );
  };

  const displayError = uploadError || props.imageUploadedError;

  return (
    <div className={props.classDiv ? props.classDiv : mainTable.grid3}>
      <div>
        <label className={props.classLabel ? props.classLabel : mainTable.label}>
          {props.title}
          <span className={props.classStar ? props.classStar : "hidden"}>*</span>
        </label>
        <input
          ref={fileInputRef}
          className={props.Class ? props.Class : mainTable.input}
          name={props.name}
          type="file"
          onChange={handleFileChange}
          disabled={props.disabled}
          tabIndex={props.tabIndex}
          accept={ALLOWED_FORMATS.map((format) => {
            switch (format) {
              case "image/jpeg":
              case "image/jpg":
                return ".jpg,.jpeg";
              case "image/png":
                return ".png";
              case "application/pdf":
                return ".pdf";
              case "application/msword":
                return ".doc";
              case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return ".docx";
              case "application/vnd.ms-excel":
                return ".xls";
              case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return ".xlsx";
              case "application/vnd.ms-powerpoint":
                return ".ppt";
              case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                return ".pptx";
              default:
                return "";
            }
          }).join(",")}
        />
        <span className="text-neutral-700 text-xs whitespace-normal block">
          {props.limitMassage}
        </span>
        {displayError && (
          <span className="text-red-500 whitespace-normal block">
            {displayError}
          </span>
        )}
      </div>

      <div className="flex py-4 md:py-0">
        <div className={props.title ? "mt-7 mr-7" : "mt-4 mr-7"}>
          <button
            type="button"
            className={
              buttonDisable
                ? mainTable.disabledSubmitButton
                : mainTable.submitButton
            }
            onClick={handleUpload}
            disabled={buttonDisable}
          >
            UPLOAD
          </button>
        </div>

        {props.showImage && props.showImage.endsWith(".pdf") ? (
          <a href={props.showImage} target="_blank" rel="noopener noreferrer">
            <img src={pdf} alt="PDF" className="w-20 h-20" />
            <p>View PDF</p>
          </a>
        ) : (
          <div>
            {props.showImage && !cancelImage ? (
              <div>
                <img
                  src={showImage.fileUrl ? showImage.fileUrl : props.showImage}
                  alt="Image"
                  className="rounded-none w-20 h-20"
                />
                {/* ✅ Show delete button only if imageDelete is true (default) */}
                {props.imageDelete !== false && (
                  <button
                    type="button"
                    className="text-red-500 ml-4 cursor-pointer"
                    onClick={handleCancel}
                  >
                    Delete
                  </button>
                )}
              </div>
            ) : props.imageShow !== false ? (
              <img src={download} alt="Image" className="rounded-none w-20 h-20" />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

FileUpload.propTypes = {
  modalName: PropTypes.string.isRequired,
  apiCall: PropTypes.string.isRequired,
  showImageData: PropTypes.func,
  classDiv: PropTypes.string,
  showImage: PropTypes.string,
  classLabel: PropTypes.string,
  mstClientId: PropTypes.string,
  createdBy: PropTypes.string,
  classStar: PropTypes.string,
  Class: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  MAX_FILE_SIZE_MB: PropTypes.number,
  ALLOWED_FORMATS: PropTypes.arrayOf(PropTypes.string),
  limitMassage: PropTypes.string,
  imageUploadedError: PropTypes.string,
  clearImageUploadError: PropTypes.func,
  disabledBtn: PropTypes.bool,
  imageShow: PropTypes.bool,
  clear: PropTypes.bool,
  imageDelete: PropTypes.bool, // ✅ NEW PROP
};

export default FileUpload;
